import {useClient} from '@gakki/context/auth-context';
import { useMutation } from "react-query";

export const usePost = (url: string, option: any = {}) => {
  const api = useClient();
  async function overrideKYCStatus(data: any) {
    console.log(data);

    const formData = new FormData();

    formData.append("file", data.file ?? "");

    return api.post(url, {data: formData, hiddenErrorMessage: option.hiddenErrorMessage });
  }

  return useMutation(overrideKYCStatus, option);
};
